import { Component } from 'vue-property-decorator'
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
])
import App from '@/App/index.vue';
import { vue } from '@/vue';
import Vue from 'vue';
import { i18n, i18nSetup } from "./i18n";
import "./polyfill";
import "./style";
import { router } from "@/galaxy-cruise/pages/router";
import * as GalaxyCrouseComponents from '@/galaxy-cruise/components'
import { develSetup } from './devel';
import { browserCheck } from './browser_check';

browserCheck()

window.addEventListener('load', start)

function start() {
    vue.setup()
    GalaxyCrouseComponents.register()
    const $root = new Vue({
        router,
        i18n,
        render: (h) => h(App),
    }).$mount('#app')
    i18nSetup($root)
    requestAnimationFrame(hideSpinner)
    develSetup($root)
}

function hideSpinner() {
    const loading = document.querySelector('.loading')!
    loading.parentElement!.removeChild(loading)
}
